import React from 'react';
import { HOME, formatEditorialDate } from '../lib/site';
import SafeIcon from '../common/SafeIcon';

const AUTHOR_PHOTO = '/dr-carlos-felipe-320.webp';

export default function ReferencesAndAuthor() {
  const refs = [
    'Folstein MF, et al. "Mini-mental state": a practical method for grading the cognitive state of patients. J Psychiatr Res. 1975.',
    'Brucki SMD, et al. Sugestões para o uso do Mini-Exame do Estado Mental no Brasil. Arq Neuropsiquiatr. 2003.',
    'Lourenço RA, Veras RP. Mini-Exame do Estado Mental: características psicométricas em idosos ambulatoriais. Rev Saúde Pública. 2006.'
  ];

  return (
    <section id="referencias" className="max-w-[800px] mx-auto px-4 py-12 border-t border-[var(--border-strong)]">
      <div className="mb-10">
        <h2 className="mb-4">Referências Bibliográficas</h2>
        <ul className="space-y-4 text-sm text-[var(--text-muted)]">
          {refs.map((ref, i) => (
            <li key={i} className="flex gap-3"><span className="text-[var(--accent)] font-bold">{i + 1}.</span>{ref}</li>
          ))}
        </ul>
      </div>

      <div className="card flex flex-col gap-6 p-6 md:flex-row md:items-start">
        <img
          src={AUTHOR_PHOTO}
          alt="Dr. Carlos Felipe"
          width="96"
          height="96"
          loading="lazy"
          className="h-24 w-24 shrink-0 rounded-[var(--radius-control)] border border-[var(--border)] object-cover"
        />
        <div>
          <h3 className="mb-1 text-xl">Dr. Carlos Felipe</h3>
          <div className="mb-2 flex flex-wrap items-center gap-x-4 gap-y-1">
            <p className="inline-flex items-center gap-1.5 text-sm font-bold text-[var(--accent)]">
              <SafeIcon name="Shield" className="h-4 w-4" />
              Médico — CRM-MG 105.721
            </p>
            <a
              href="https://cadu.online"
              target="_blank"
              rel="me noopener noreferrer"
              className="inline-flex items-center text-sm text-[var(--primary)] hover:underline"
            >
              cadu.online ↗
            </a>
          </div>
          <p className="text-sm leading-relaxed text-[var(--text-muted)]">
            Responsável pela revisão técnica e editorial. Este site possui finalidade educacional e não substitui avaliação médica profissional.
          </p>
          <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-xs text-[var(--text-muted)]">
            <span>Publicado: {formatEditorialDate(HOME.publishedAt)}</span>
            <span>Atualizado: {formatEditorialDate(HOME.lastModified)}</span>
            <span>Última revisão editorial: {formatEditorialDate(HOME.lastReviewed)}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
